export function teamStablefordQuota(
  parPointValue: number,
  holeCount: number,
  playingHandicap: number,
): number {
  return (parPointValue * holeCount) - playingHandicap;
}
